import React from 'react'
import {Popup} from 'react-weui'
import '../../../css/common/CouponPopupOpen.css'

class couponV7Popup extends React.Component{
    constructor(){
        super()
        this.state = {
            popupShown : true
        }
    }



    render(){
        return (
            <div className="couponv7popup">
            <Popup
                show={this.state.popupShown}
                className="couponv7popup_weui_popup"
            >
                    <div className="CouponPopupwrap">
                        <div className="couponv7popup_hb">
                            <div className="couponv7popup_hb_cover">
                                <img className="couponv7popup_hb_back" src="https://static-cos.lycheer.net/picture/8173011_b1958f84f7e448afa1d709375edc0cde.jpg" alt=""/>
                                <img className="couponv7popup_hb_bottom" src="https://static-cos.lycheer.net/picture/8173011_de8d7859595881b409fb9ffcb9c839f7.jpg" alt=""/>
                            </div>

                            <div className="couponv7popup_hb_card">
                                    <div className="moneyConponGet">{this.props.conponTotal}<span>元</span></div>
                                    <img className="couponv7popup_hb_card_modules" src="https://static-cos.lycheer.net/picture/8173011_e5dbb572ffda8a11277af11702f934b6.jpg" alt=""/>
                                    <img className="couponv7popup_hb_man" src="https://static-cos.lycheer.net/picture/8173011_17b183bdfa4e3896d195aaa507371faf.jpg" alt=""/>
                                    <img className="couponv7popup_hb_line" src="https://static-cos.lycheer.net/picture/8173011_6a11f3e9c1b420c9a85b51c424013ac9.jpg" alt=""/>
                            </div>

                        </div>
                        <div className="hideTheCard"></div>
                        <div className="couponv7popup_hb_bottom_click">
                            <img src="https://static-cos.lycheer.net/picture/8173011_fff7f18750e86adffabb6db822f2f51f.jpg-picmsg420" onClick={this.props.handleGetConpon} alt=""/>
                        </div>

                    </div>
            </Popup>
            </div>
        )
    }
}

export default couponV7Popup



// WEBPACK FOOTER //
// ./src/components/activity/couponSPA/couponV7Popup.js